<template>
  <div>
    <MasterLayout>
      <div class="voucher_first_row">
        <div class="card_container" style="flex: 0 0 25%; border-radius: 10px">
          <div class="row align-items-center voucher_buttons_row">
            <div class="col-md-4 voucher_btn_div mt-3">
              <div
                class="voucher_button fund__wallet_tab"
                @click="changeTab('show all')"
                :class="[activeStatus === 'show all' ? 'activeStatus' : null]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="43.031"
                  height="48"
                  viewBox="0 0 43.031 48"
                >
                  <path
                    id="approval"
                    d="M20.156,46.125A1.875,1.875,0,0,1,18.281,48H7.5A7.508,7.508,0,0,1,0,40.5V7.5A7.508,7.508,0,0,1,7.5,0H30.552a7.509,7.509,0,0,1,7.5,7.5V27.375a1.875,1.875,0,0,1-3.75,0V7.5a3.754,3.754,0,0,0-3.75-3.75H7.5A3.754,3.754,0,0,0,3.75,7.5v33A3.754,3.754,0,0,0,7.5,44.25H18.281a1.875,1.875,0,0,1,1.875,1.875ZM42.248,30.538a1.875,1.875,0,0,0-2.616.433L30.39,43.88a1.071,1.071,0,0,1-1.542.08l-5.983-5.745a1.875,1.875,0,0,0-2.6,2.7l5.989,5.751A4.836,4.836,0,0,0,29.583,48q.159,0,.318-.011A4.832,4.832,0,0,0,33.338,46.2c.022-.027.043-.055.063-.083l9.279-12.962a1.875,1.875,0,0,0-.433-2.616ZM28.677,11.25H9.365a1.875,1.875,0,0,0,0,3.75H28.677a1.875,1.875,0,0,0,0-3.75Zm1.875,9.375a1.875,1.875,0,0,0-1.875-1.875H9.365a1.875,1.875,0,0,0,0,3.75H28.677A1.875,1.875,0,0,0,30.552,20.625ZM9.365,26.25a1.875,1.875,0,0,0,0,3.75H21.094a1.875,1.875,0,0,0,0-3.75Zm0,0"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div class="text-center voucher_type">
                {{ $t("text.fundWalletRequest.showAll") }}
              </div>
            </div>
            <div class="col-md-4 mt-3 voucher_btn_div">
              <div
                class="voucher_button"
                @click="changeTab('approved')"
                :class="[activeStatus === 'approved' ? 'activeStatus' : null]"
              >
                <svg
                  id="maps-and-flags"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                >
                  <g id="Group_540" data-name="Group 540">
                    <g id="Group_539" data-name="Group 539">
                      <path
                        id="Path_740"
                        data-name="Path 740"
                        d="M24,0A24,24,0,1,0,48,24,23.987,23.987,0,0,0,24,0Zm0,44.8A20.8,20.8,0,1,1,44.8,24,20.824,20.824,0,0,1,24,44.8Z"
                        fill="white"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_542"
                    data-name="Group 542"
                    transform="translate(10.827 14.712)"
                  >
                    <g id="Group_541" data-name="Group 541">
                      <path
                        id="Path_741"
                        data-name="Path 741"
                        d="M141.365,157.4a1.6,1.6,0,0,0-2.263,0l-14.244,14.244L118.219,165a1.6,1.6,0,1,0-2.263,2.263l7.771,7.771a1.6,1.6,0,0,0,2.263,0l15.376-15.376A1.6,1.6,0,0,0,141.365,157.4Z"
                        transform="translate(-115.487 -156.93)"
                        fill="white"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="text-center voucher_type">
                {{ $t("text.fundWalletRequest.approved") }}
              </div>
            </div>
            <div class="col-md-4 mt-3 voucher_btn_div">
              <div
                class="voucher_button"
                @click="changeTab('pending')"
                :class="[activeStatus === 'pending' ? 'activeStatus' : null]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="42.682"
                  height="42.579"
                  viewBox="0 0 42.682 42.579"
                >
                  <g id="pending" transform="translate(0 0)">
                    <path
                      id="Path_742"
                      data-name="Path 742"
                      d="M278.7,268.369a9.005,9.005,0,1,0-15.024,6.7,9.014,9.014,0,0,0,15.024-6.7Zm-9.021,7.741a7.747,7.747,0,1,1,5.189-13.512,7.75,7.75,0,0,1-5.189,13.512Zm0,0"
                      transform="translate(-238.955 -237.731)"
                      fill="white"
                    />
                    <path
                      id="Path_743"
                      data-name="Path 743"
                      d="M308.461,290.473a.63.63,0,0,0-.63.63v5.157h-4.22a.63.63,0,1,0,0,1.26h4.85a.63.63,0,0,0,.63-.63V291.1A.63.63,0,0,0,308.461,290.473Zm0,0"
                      transform="translate(-277.724 -266.258)"
                      fill="white"
                    />
                    <path
                      id="Path_744"
                      data-name="Path 744"
                      d="M61.081,49.09H43.363a1.74,1.74,0,0,0-1.738,1.739V57a1.74,1.74,0,0,0,1.738,1.738H61.081A1.74,1.74,0,0,0,62.819,57V50.828A1.74,1.74,0,0,0,61.081,49.09ZM61.559,57a.479.479,0,0,1-.478.479H43.363A.479.479,0,0,1,42.885,57V50.828a.479.479,0,0,1,.478-.479H61.081a.479.479,0,0,1,.478.479Zm0,0"
                      transform="translate(-38.155 -44.997)"
                      fill="white"
                    />
                    <path
                      id="Path_745"
                      data-name="Path 745"
                      d="M89.346,80.563h-14.5a.63.63,0,1,0,0,1.26h14.5a.63.63,0,0,0,0-1.26Zm0,0"
                      transform="translate(-68.029 -73.846)"
                      fill="white"
                    />
                    <path
                      id="Path_746"
                      data-name="Path 746"
                      d="M175.933,118.3h-2.358a.63.63,0,0,0,0,1.26h2.358a.63.63,0,0,0,0-1.26Zm0,0"
                      transform="translate(-158.528 -108.439)"
                      fill="white"
                    />
                    <path
                      id="Path_747"
                      data-name="Path 747"
                      d="M80.555,118.3H74.845a.63.63,0,1,0,0,1.26h5.711a.63.63,0,0,0,0-1.26Zm0,0"
                      transform="translate(-68.028 -108.439)"
                      fill="white"
                    />
                    <path
                      id="Path_748"
                      data-name="Path 748"
                      d="M89.346,228.953h-14.5a.63.63,0,1,0,0,1.26h14.5a.63.63,0,0,0,0-1.26Zm0,0"
                      transform="translate(-68.029 -209.866)"
                      fill="white"
                    />
                    <path
                      id="Path_749"
                      data-name="Path 749"
                      d="M78.978,266.7H74.845a.63.63,0,1,0,0,1.26h4.133a.63.63,0,0,0,0-1.26Zm0,0"
                      transform="translate(-68.029 -244.462)"
                      fill="white"
                    />
                    <path
                      id="Path_750"
                      data-name="Path 750"
                      d="M74.845,378.6H85.223a.63.63,0,0,0,0-1.26H74.845a.63.63,0,1,0,0,1.26Zm0,0"
                      transform="translate(-68.028 -345.887)"
                      fill="white"
                    />
                    <path
                      id="Path_751"
                      data-name="Path 751"
                      d="M79.884,415.086H74.845a.63.63,0,1,0,0,1.26h5.039a.63.63,0,0,0,0-1.26Zm0,0"
                      transform="translate(-68.028 -380.483)"
                      fill="white"
                    />
                    <path
                      id="Path_752"
                      data-name="Path 752"
                      d="M169.38,415.086h-3.867a.63.63,0,1,0,0,1.26h3.867a.63.63,0,0,0,0-1.26Zm0,0"
                      transform="translate(-151.138 -380.483)"
                      fill="white"
                    />
                    <path
                      id="Path_753"
                      data-name="Path 753"
                      d="M38.717,21.743a11.926,11.926,0,0,0-10.584-2.769V2.026A2.028,2.028,0,0,0,26.107,0H2.026A2.028,2.028,0,0,0,0,2.026V40.554a2.028,2.028,0,0,0,2.026,2.025H26.107a2.017,2.017,0,0,0,1.3-.472,11.987,11.987,0,0,0,7.547-.3.63.63,0,1,0-.443-1.179,10.685,10.685,0,1,1,2.114-1.079.63.63,0,1,0,.695,1.051,11.951,11.951,0,0,0,1.4-18.862ZM20.775,37.227H5.207a.479.479,0,0,1-.478-.479V30.572a.479.479,0,0,1,.478-.479H18.8a11.959,11.959,0,0,0,1.973,7.133ZM23.4,21.2a12.007,12.007,0,0,0-3.125,3.655H5.207a.479.479,0,0,1-.478-.479V18.2a.479.479,0,0,1,.478-.479H22.926a.479.479,0,0,1,.478.479Zm3.47-1.874a11.831,11.831,0,0,0-2.21,1.016V18.2a1.74,1.74,0,0,0-1.738-1.739H5.207A1.74,1.74,0,0,0,3.47,18.2v6.176a1.74,1.74,0,0,0,1.738,1.738H19.676a11.874,11.874,0,0,0-.75,2.718H5.207A1.74,1.74,0,0,0,3.47,30.572v6.176a1.74,1.74,0,0,0,1.738,1.739H21.737A11.966,11.966,0,0,0,25.4,41.32H2.026a.767.767,0,0,1-.767-.766V2.026a.767.767,0,0,1,.767-.766H26.107a.767.767,0,0,1,.767.766Zm0,0"
                      transform="translate(0)"
                      fill="white"
                    />
                  </g>
                </svg>
              </div>
              <div class="text-center voucher_type">
                {{ $t("text.fundWalletRequest.pending") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="voucher_first_row_right_section mr-3 pump__bg"
          style="border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.8), rgb(12, 4, 31, 0.8)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-6 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  <span>
                    <img
                      src="@/assets/img/purse.png"
                      height="40px"
                      class="mr-3"
                    />
                  </span>
                  {{ $t("text.fundWalletRequest.title") }}
                </h3>
              </div>
              <div class="col-md-6 text-right section___column_2">
                <div class="row align-items-center"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="section__row mt-3">
        <div class>
          <div class>
            <ejs-grid
              v-show="!showLoader && activeStatus === 'approved'"
              ref="approvedDataGrid"
              :created="refreshApprovedDataGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="approvedToolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="40" headerText="#"></e-column>
                <e-column
                  field="depositorName"
                  width="250"
                  :headerText="$t('text.fundWalletRequest.depositorsName')"
                ></e-column>
                <e-column
                  field="amountPaid"
                  width="200"
                  format="N2"
                  :headerText="`${$t('text.fundWalletRequest.amountPaid')} (${
                    company ? company.currency : ''
                  })`"
                ></e-column>
                <e-column
                  field="bankName"
                  width="200"
                  :headerText="$t('text.fundWalletRequest.bankName')"
                ></e-column>
                <e-column
                  field="depositeSlipNo"
                  width="150"
                  :headerText="$t('text.fundWalletRequest.depositSlipNo')"
                ></e-column>
                <e-column
                  field="datePaid"
                  width="210"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.fundWalletRequest.datePaid')"
                ></e-column>
                <e-column
                  field="dateReq"
                  width="210"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.fundWalletRequest.requestDate')"
                ></e-column>
                <e-column
                  field="isAdded"
                  width="200"
                  :headerText="$t('text.fundWalletRequest.walletCredited')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <ejs-grid
              v-show="!showLoader && activeStatus === 'show all'"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="40" headerText="#"></e-column>
                <e-column
                  field="depositorName"
                  width="250"
                  :headerText="$t('text.fundWalletRequest.depositorsName')"
                ></e-column>
                <e-column
                  field="amountPaid"
                  width="200"
                  format="N2"
                  :headerText="`Amount paid (${
                    company ? company.currency : ''
                  })`"
                ></e-column>
                <e-column
                  field="bankName"
                  width="200"
                  :headerText="$t('text.fundWalletRequest.bankName')"
                ></e-column>
                <e-column
                  field="depositSlipNo"
                  width="150"
                  :headerText="$t('text.fundWalletRequest.depositSlipNo')"
                ></e-column>
                <e-column
                  field="datePaid"
                  width="210"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.fundWalletRequest.datePaid')"
                ></e-column>
                <e-column
                  field="dateReq"
                  width="210"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.fundWalletRequest.requestDate')"
                ></e-column>
                <e-column
                  field="isAdded"
                  width="200"
                  :headerText="$t('text.fundWalletRequest.walletCredited')"
                ></e-column>
                <e-column
                  width="250"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <ejs-grid
              v-show="!showLoader && activeStatus === 'pending'"
              ref="pendingDataGrid"
              :created="refreshPendingDataGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="pendingDataGridToolBarClick"
              :excelQueryCellInfo="excelQueryCellInfo"
              :locale="usedLang"
            >
              <e-columns>
                <e-column field="index" width="40" headerText="#"></e-column>
                <e-column
                  field="depositorName"
                  width="220"
                  :headerText="$t('text.fundWalletRequest.depositorsName')"
                ></e-column>
                <e-column
                  field="amountPaid"
                  width="200"
                  format="N2"
                  :headerText="`Amount paid (${
                    company ? company.currency : ''
                  })`"
                ></e-column>
                <e-column
                  field="bankName"
                  width="200"
                  :headerText="$t('text.fundWalletRequest.bankName')"
                ></e-column>
                <e-column
                  field="depositSlipNo"
                  width="150"
                  :headerText="$t('text.fundWalletRequest.depositSlipNo')"
                ></e-column>
                <e-column
                  field="datePaid"
                  width="210"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.fundWalletRequest.datePaid')"
                ></e-column>
                <e-column
                  field="dateReq"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.fundWalletRequest.requestDate')"
                  width="210"
                ></e-column>
                <e-column
                  field="isAdded"
                  width="200"
                  :headerText="$t('text.fundWalletRequest.walletCredited')"
                ></e-column>
                <e-column
                  width="250"
                  :template="buttonsTemplate"
                  :headerText="$t('text.actionButtons.title')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;
Vue.prototype.$eventHub = new Vue();
export default {
  title: "Fund Wallet Request :: Epump Portal",
  name: "FundWalletRequest",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "dateTime", format: "dd/MM/yyyy hh:mm a" },
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      company: null,
      activeStatus: "show all",
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      buttonsTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template: `<div> 
              <button v-if="data.isAdded === 'No'" class="mailRecipient_btn assign_branch" v-on:click="approveRequest(data.id)">{{data.approveRequestButton}}</button> 
              </div>`,
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              approveRequest(walletId) {
                this.$eventHub.$emit("approveRequest", walletId);
              },
            },
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (
      this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company.id
    ) {
      this.getFundRequest();
    }
    this.$eventHub.$on("approveRequest", (walletId) => {
      this.approveRequest(walletId);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("approveRequest");
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getFundRequest();
      }
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "datePaid" || args.column.field == "dateReq") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY hh:mm A");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          if (this.$refs.dataGrid !== null) {
            this.$refs.dataGrid.pdfExport();
          } else if (this.$refs.expiredDataGrid !== null) {
            this.$refs.expiredDataGrid.pdfExport();
          } else if (this.$refs.transferedDataGrid !== null) {
            this.$refs.transferedDataGrid.pdfExport();
          }
          break;
        case "Excel Export":
          if (this.$refs.dataGrid !== null) {
            this.$refs.dataGrid.excelExport();
          } else if (this.$refs.expiredDataGrid !== null) {
            this.$refs.expiredDataGrid.excelExport();
          } else if (this.$refs.transferedDataGrid !== null) {
            this.$refs.transferedDataGrid.excelExport();
          }
          break;
      }
    },
    approveRequest(walletId) {
      this.showLoader = true;
      // let companyID;
      // if (localStorage.getItem("companyDetails") !== null) {
      //   companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      // }
      let data = {};
      this.axios
        .post(
          `${
            configObject.apiBaseUrl
          }/Wallet/ApproveFundRequest?id=${walletId}&corpId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
              ? this.$route.query.companyId
                ? this.$route.query.companyId
                : this.company.id
              : this.company.id
          }`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.getFundRequest();
          this.$toast.open({
            message:
              response.status === 200
                ? this.$t("text.fundWalletRequest.successfullyApproved")
                : response.data.message,
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {});
    },
    pendingDataGridToolBarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.pendingDataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.pendingDataGrid.excelExport();
          break;
      }
    },
    approvedToolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.approvedDataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.approvedDataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid === null) {
        this.$refs.dataGrid.refresh();
      }
    },
    refreshApprovedDataGrid() {
      this.$refs.approvedDataGrid.refresh();
    },
    refreshPendingDataGrid() {
      this.$refs.pendingDataGrid.refresh();
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    changeTab(tab) {
      this.activeStatus = tab;
      this.getFundRequest();
    },
    decimalThousand(number) {
      if (!isFinite(number)) {
        return "0.00";
      }
      return number
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getFundRequest() {
      this.showLoader = true;
      let grid = this.$refs.dataGrid;
      let pendingGrid = this.$refs.pendingDataGrid;
      let approvedDataGrid = this.$refs.approvedDataGrid;

      let url;

      if (this.activeStatus === "show all") {
        let string = "show all";
        url = `${
          configObject.apiBaseUrl
        }/Wallet/BankTransactions?status=${string}&companyId=${
          this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id
        }`;
      }
      if (this.activeStatus === "approved") {
        let string = "approved";
        url = `${
          configObject.apiBaseUrl
        }/Wallet/BankTransactions?status=approved&companyId=${
          this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id
        }`;
      }
      if (this.activeStatus === "pending") {
        let string = "pending";
        url = `${
          configObject.apiBaseUrl
        }/Wallet/BankTransactions?status=pending&companyId=${
          this.$route.query.companyId
            ? this.$route.query.companyId
            : this.company.id
        }`;
      }

      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          let index = 0;
          this.showLoader = false;
          response.data.forEach((request) => {
            index++;
            if (request.isAdded) {
              request.isAdded = "Yes";
            } else {
              request.isAdded = "No";
            }
            request.index = index;
            request.approveRequestButton = this.$t(
              "text.fundWalletRequest.approveRequest"
            );
          });

          if (this.activeStatus === "show all") {
            grid.ej2Instances.setProperties({ dataSource: response.data });
            this.refreshGrid();
          }
          if (this.activeStatus === "pending") {
            pendingGrid.ej2Instances.setProperties({
              dataSource: response.data,
            });
            this.refreshPendingDataGrid();
          }
          if (this.activeStatus === "approved") {
            approvedDataGrid.ej2Instances.setProperties({
              dataSource: response.data,
            });
            this.refreshApprovedDataGrid();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
